<div class="px-1">
  <div
    class="mt-1 mb-1 d-flex align-items-center justify-content-between top-container"
  >
    <div class="main-title">
      {{ 'tooltip.smart_score.break_down' | translate }}
    </div>
    <wilson-score-display
      [score]="smartScores[ShiftSmartScoreName.ShiftSmartScore]"
    ></wilson-score-display>
  </div>
  @if (smartScores[ShiftSmartScoreName.ShiftTransferScore]) {
    <div class="mt-1 mb-1 d-flex align-items-center justify-content-between">
      <div class="score-title">
        {{ 'tooltip.smart_score.shift_transfer' | translate }}
      </div>
      <wilson-score-display
        [score]="smartScores[ShiftSmartScoreName.ShiftTransferScore]"
      ></wilson-score-display>
    </div>
  }

  @if (smartScores[ShiftSmartScoreName.ShiftWorktimeScore]) {
    <div class="mt-1 mb-1 d-flex align-items-center justify-content-between">
      <div class="score-title">
        {{ 'tooltip.smart_score.work_time' | translate }}
      </div>
      <wilson-score-display
        [score]="smartScores[ShiftSmartScoreName.ShiftWorktimeScore]"
      ></wilson-score-display>
    </div>
  }

  @if (smartScores[ShiftSmartScoreName.ShiftProductivityScore]) {
    <div class="mt-1 mb-1 d-flex align-items-center justify-content-between">
      <div class="score-title">
        {{ 'tooltip.smart_score.productivity' | translate }}
      </div>
      <wilson-score-display
        [score]="smartScores[ShiftSmartScoreName.ShiftProductivityScore]"
      ></wilson-score-display>
    </div>
  }

  @if (smartScores[ShiftSmartScoreName.ShiftRequirementsScore]) {
    <div class="mt-1 mb-1 d-flex align-items-center justify-content-between">
      <div class="score-title">
        {{ 'tooltip.smart_score.requirements' | translate }}
      </div>
      <wilson-score-display
        [score]="smartScores[ShiftSmartScoreName.ShiftRequirementsScore]"
      ></wilson-score-display>
    </div>
  }

  @if (smartScores[ShiftSmartScoreName.RenewQualificationsScore]) {
    <div class="mt-1 mb-1 d-flex align-items-center justify-content-between">
      <div class="score-title">
        {{ 'tooltip.smart_score.renew_qualifications_score' | translate }}
      </div>
      <wilson-score-display
        [score]="smartScores[ShiftSmartScoreName.RenewQualificationsScore]"
      ></wilson-score-display>
    </div>
  }

  @if (smartScores[ShiftSmartScoreName.QualificationFlexibilityScore]) {
    <div class="mt-1 mb-1 d-flex align-items-center justify-content-between">
      <div class="score-title">
        {{ 'tooltip.smart_score.qualification_flexibility_score' | translate }}
      </div>
      <wilson-score-display
        [score]="smartScores[ShiftSmartScoreName.QualificationFlexibilityScore]"
      ></wilson-score-display>
    </div>
  }

  @if (smartScores[ShiftSmartScoreName.RestTimeBetweenShiftsScore]) {
    <div class="mt-1 mb-1 d-flex align-items-center justify-content-between">
      <div class="score-title">
        {{ 'tooltip.smart_score.rest_time_between_shifts_score' | translate }}
      </div>
      <wilson-score-display
        [score]="smartScores[ShiftSmartScoreName.RestTimeBetweenShiftsScore]"
      ></wilson-score-display>
    </div>
  }

  @if (smartScores[ShiftSmartScoreName.RobustnessScore]) {
    <div class="mt-1 mb-1 d-flex align-items-center justify-content-between">
      <div class="score-title">
        {{ 'tooltip.smart_score.robustness_score' | translate }}
      </div>
      <wilson-score-display
        [score]="smartScores[ShiftSmartScoreName.RobustnessScore]"
      ></wilson-score-display>
    </div>
  }

  @if (smartScores[ShiftSmartScoreName.OvertimeAccountScore]) {
    <div class="mt-1 mb-1 d-flex align-items-center justify-content-between">
      <div class="score-title">
        {{ 'tooltip.smart_score.overtime_account_score' | translate }}
      </div>
      <wilson-score-display
        [score]="smartScores[ShiftSmartScoreName.OvertimeAccountScore]"
      ></wilson-score-display>
    </div>
  }
</div>
